<template>
    <div id="app">
        <div class="custom-download-buttons">
            <button
                class="download-btn postman-btn"
                @click="downloadPostman"
                :disabled="isLoading"
            >
                <span v-if="isLoading" class="loading-spinner"></span>
                {{ isLoading ? 'Baixando...' : 'Download Postman.json' }}
            </button>
        </div>

        <redoc-wrapper
            :spec-or-spec-url="json"
            :options="redocOptions"
        ></redoc-wrapper>
    </div>
</template>

<script>
import RedocWrapper from '@hnluu8/vue-redoc-wrapper';
import UtilsService from '@/services/UtilsService';

export default {
    name: 'app',
    components: {
        RedocWrapper
    },
    data() {
        return {
            // https://github.com/Redocly/redoc#redoc-options-object
            redocOptions: {
                hideDownloadButton: false
            },
            json: 'recuperi.json',
            isLoading: false
        };
    },
    methods: {
        async downloadPostman() {
            if (this.isLoading) return;

            this.isLoading = true;
            try {
                const utilsService = new UtilsService(this.$http, this.$store);
                const response = await utilsService.downloadApiDoc();
                let blob;
                if (response.data instanceof Blob && response.data.size > 0) {
                    blob = response.data;
                } else if (typeof response.data === 'string') {
                    blob = new Blob([response.data], {
                        type: 'application/json'
                    });
                } else if (response.data && typeof response.data === 'object') {
                    blob = new Blob([JSON.stringify(response.data, null, 2)], {
                        type: 'application/json'
                    });
                } else {
                    throw new Error('Resposta inválida da API');
                }
                if (blob.size === 0) {
                    throw new Error('Arquivo vazio recebido da API');
                }
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'postman-collection.json';
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Erro ao baixar o arquivo:', error);
                alert('Erro ao baixar o arquivo: ' + error.message);
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.custom-download-buttons {
    position: fixed;
    top: 70px;
    right: 20px;
    z-index: 1001;
}

.download-btn {
    background: #4caf50;
    border: none;
    color: white;
    padding: 8px 16px;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    font-family: inherit;
    transition: background-color 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: relative;
}

.download-btn:hover:not(:disabled) {
    background: #45a049;
}

.download-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.postman-btn {
    background: #ff6c37;
}

.postman-btn:hover:not(:disabled) {
    background: #e55a2e;
}

.loading-spinner {
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid #ffffff;
    border-radius: 50%;
    border-top-color: transparent;
    animation: spin 1s ease-in-out infinite;
    margin-right: 8px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
